import { useSessionStore } from '@/stores'
import type { SessionData } from '@/stores/useSessionStore'

// One invariant, one module: while a drawer owns the funnel, the mounted portal page keeps
// the step it was rendered from. The pin is that held step; `state.session` is the live one.
// Every OMP call site goes through here rather than poking the store's pin fields.

export function isDrawerOwningFunnel(): boolean {
  return !!useSessionStore.getState().portalPin
}

export function takeFunnel(step: SessionData): void {
  useSessionStore.getState().pinPortalSession(step)
}

export function returnFunnel(): void {
  useSessionStore.getState().releasePortalPin()
}

// The action never ran, so the payload's recomputed fields must not stick.
export function restoreStep(step: SessionData): void {
  useSessionStore.setState(state => {
    state.session = step
    state.popupSession = null
    state.portalPin = null
  })
}
